import React from "react";


import {
    Col, Row
} from "react-bootstrap";


import {
    BlackoutComponent
} from "@Elements";

import {
    SvgIconComponent
} from "@Components/Elements";

import {
    ButtonComponent
} from "@Components/Forms";


import IconXCloseSmBrown from "./@Icons/icon-x_close-sm-brown.svg";


import "./index.scss";


interface DefaultPopupComponentProps {
    popupHeaderText?: string;
    popupCloseButtonCallback?: () => void;
    popupButtonText?: string;
    popupButtonClickCallback?: () => void;
    children?: React.ReactNode | React.ReactNode[];
}


export const DefaultPopupComponent:React.FC<DefaultPopupComponentProps> = ({
    popupHeaderText, popupCloseButtonCallback,
    popupButtonText, popupButtonClickCallback,
    children
}) => {


    if (!children) {
        return null;
    }


    return (
        <BlackoutComponent>

            <Col xs={12} lg={6} xl={4} className={'popup-component default-popup-component'}>
                <Row className={'popup-component__popup-container default-popup-component__popup-container'}>

                    <span className={'popup-component__popup-close-button default-popup-component__popup-close-button'}>
                        <SvgIconComponent
                            iconSource={IconXCloseSmBrown} className={'popup-component__popup-close-button__button-icon default-popup-component__popup-close-button__button-icon'}
                            onClick={popupCloseButtonCallback}
                        />
                    </span>

                    {popupHeaderText &&
                    <Col xs={12} className={'popup-component__popup-header default-popup-component__popup-header'}>
                        <span>{popupHeaderText}</span>
                    </Col>
                    }

                    {children &&
                    <Col xs={12} className={'popup-component__popup-content default-popup-component__popup-content'}>
                        <Row className={'popup-component__popup-content__content-container default-popup-component__popup-content__content-container'}>
                            {children}
                        </Row>
                    </Col>
                    }

                    {popupButtonText &&
                    <Col xs={12} className={'popup-component__popup-button'}>
                        <ButtonComponent
                            text={popupButtonText}
                            callback={popupButtonClickCallback}
                        />
                    </Col>
                    }

                </Row>
            </Col>

        </BlackoutComponent>
    );

};


export default DefaultPopupComponent;
